import { useState, useCallback } from "react";
import { post } from "../networking/RequestService";
import moment from "moment";

const useGetTaskLists = () => {
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [staticTasks, setStaticTasks] = useState([]);
    const [staticLoading, setStaticLoading] = useState(false);
    const [staticError, setStaticError] = useState(null);

    const fetchTaskLists = useCallback(async (customParams = {}) => {
        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "gorevListe",
                tarih: customParams.selectedDate ? moment(customParams.selectedDate).valueOf() : moment().valueOf(),
                old: 1,
                start: 0,
                startOld: 0,
                ...customParams,
            });
            setTasks(res.data);
        } catch (err) {
            setError(err);
            setTasks(null);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchStaticTaskList = useCallback(async () => {
        setStaticLoading(true);
        setStaticError(null);
        try {
            const staticDate = moment("2026-12-01").valueOf(); // 01.12.2026 tarihi
            const res = await post({
                fn: "gorevListe",
                tarih: staticDate,
                selectedDate: staticDate,
                old: 1,
                start: 0,
                startOld: 0,
            });
            setStaticTasks(res.data);
        } catch (err) {
            setStaticError(err);
            setStaticTasks(null);
        } finally {
            setStaticLoading(false);
        }
    }, []);

    return {
        tasks,
        loading,
        error,
        refetch: fetchTaskLists,
        setTasks,
        staticTasks,
        staticLoading,
        staticError,
        fetchStaticTaskList,
    };
};

export default useGetTaskLists;
